export const contactDetails = (tempContact) => [
  {
    type: "Contact Name",
    name: tempContact?.name ?? "",
    primary: tempContact?.mobile?.mobile ?  `${tempContact?.mobile?.mobile_code} ${tempContact?.mobile?.mobile}` : "" ,
    secondary: tempContact?.alternative_mobile?.mobile ? `${tempContact?.alternative_mobile?.mobile} ${tempContact?.alternative_mobile?.mobile_code}` : ""
  },
];